import React from 'react';
import styled from 'styled-components';

const LoaderWrapper = styled.div``;

export default () => {
  return <LoaderWrapper>Loading...</LoaderWrapper>;
};
